import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Colxx } from "../common/CustomBootstrap";
import { Row, Button } from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";

const BookingHeadSection = ({ history, toggleModal, hotelConfig }) => {
  const goBack = () => history.goBack();

  return (
    <Row>
      <Colxx xxs="12" lg="3" className="mb-4">
        <Button type="button" color="outline-info" size="sm"
          onClick={goBack}
          className="btn outline-light flex-grow-1 "
        >
          <i className="iconsminds-arrow-left booking-heading-icon" />
          <IntlMessages id="bookingDetails.back_button" />
        </Button>
      </Colxx>

      <Colxx xxs="12" lg="6" className="mb-4">
        <h1 className="text-center align-middle w-100">
          <span>
            <IntlMessages id="booking.booking_summary" />
          </span>
        </h1>
      </Colxx>

      {hotelConfig.featureUpdate?.newBookingRequest && (
        <Colxx xxs="12" lg="3" className="mb-4 text-right">
          <Button color="primary" size="lg"
            onClick={toggleModal}
            className="btn outline-light flex-grow-1 "
          >
            <IntlMessages id="request.add-new" />
          </Button>{" "}
        </Colxx>
      )}
    </Row>
  );
};

const mapStateToProps = ({ settings }) => {
  const { hotelConfig } = settings;
  return { hotelConfig };
};

const mapActionsToProps = {
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(BookingHeadSection)
);
